import { createFileRoute } from '@tanstack/react-router';

import { PageContainer } from '../components/layout/page-container';
import { ArticleList } from '../features/articles/article-list';

/**
 * `/articles/pending` — 비공개 아티클: 내 초안 · 검수 대기, 관리자면 검수 대기 큐 전부.
 * 공개 목록(`/articles`)의 「비공개」 알약이 여기로 온다. CSR (auth-only; SSR 안 함).
 */
export const Route = createFileRoute('/articles/pending')({
  // 로그인 화면 — 세션이 브라우저에만 있다. 서버는 레이아웃만 그린다(docs/SSR.md).
  ssr: false,
  component: () => (
    <PageContainer>
      <ArticleList view="private" />
    </PageContainer>
  ),
});
